import { lazy } from "react";

const ImportList = lazy(() => import("./List"));
const ImportCreate = lazy(() => import("./Create"));
const ImportPrint = lazy(() => import("./Print"));
const ImportUpdate = lazy(() => import("./Update"));
const UpdateVat = lazy(() => import("./UpdateVat"));

const ImportOutsideList = lazy(() => import("./OutsideList"));
const ImportOutsideCreate = lazy(() => import("./OutsideCreate"));
const ImportOutsideUpdate = lazy(() => import("./OutsideUpdate"));

export {
  ImportCreate,
  ImportList,
  ImportOutsideCreate,
  ImportOutsideList,
  ImportOutsideUpdate,
  ImportPrint,
  ImportUpdate,
  UpdateVat,
};
